import { httpClient } from "./client";
import type { Schema } from "../types/generated";

export type TournamentScheduleState = Schema["TournamentScheduleState"];
export type TournamentSchedulePolicyCommand =
  Schema["TournamentSchedulePolicyCommand"];
export type TournamentSchedulePlanRequest =
  Schema["TournamentSchedulePlanRequest"];
export type TournamentSchedulePlan = Schema["TournamentSchedulePlan"];
export type TournamentPlanCommand = Schema["TournamentPlanCommand"];
export type TournamentPublishedSchedule = Schema["TournamentPublishedSchedule"];
export type TournamentScheduleReview = Schema["TournamentScheduleReview"];
export type TournamentScheduleReviewCommand =
  Schema["TournamentScheduleReviewCommand"];
export type TournamentDispatcherState = Schema["TournamentDispatcherState"];
export type TournamentDispatcherControlCommand =
  Schema["TournamentDispatcherControlCommand"];
export type TournamentDispatchDecision = Schema["TournamentDispatchDecision"];

const route = (tournamentId: string) =>
  `/tournaments/${encodeURIComponent(tournamentId)}`;

/** Generated-contract-only transports for Phase-2 schedule and dispatch. */
export const tournamentScheduleApi = {
  getTournamentScheduleState: (tournamentId: string) =>
    httpClient.get<TournamentScheduleState>(
      `${route(tournamentId)}/schedule-state`,
    ),

  updateTournamentSchedulePolicy: (
    tournamentId: string,
    command: TournamentSchedulePolicyCommand,
  ) =>
    httpClient.put<TournamentScheduleState>(
      `${route(tournamentId)}/schedule-policy`,
      command,
    ),

  previewTournamentSchedulePlan: (
    tournamentId: string,
    request: TournamentSchedulePlanRequest,
  ) =>
    httpClient.post<TournamentSchedulePlan>(
      `${route(tournamentId)}/schedule-plans`,
      request,
    ),

  listTournamentSchedulePlans: (tournamentId: string) =>
    httpClient.get<TournamentSchedulePlan[]>(
      `${route(tournamentId)}/schedule-plans`,
    ),

  getTournamentSchedulePlan: (tournamentId: string, planId: string) =>
    httpClient.get<TournamentSchedulePlan>(
      `${route(tournamentId)}/schedule-plans/${encodeURIComponent(planId)}`,
    ),

  applyTournamentSchedulePlanCommand: (
    tournamentId: string,
    planId: string,
    command: TournamentPlanCommand,
  ) =>
    httpClient.post<TournamentSchedulePlan>(
      `${route(tournamentId)}/schedule-plans/${encodeURIComponent(planId)}/commands`,
      command,
    ),

  getTournamentSchedulePlanReview: (tournamentId: string, planId: string) =>
    httpClient.get<TournamentScheduleReview>(
      `${route(tournamentId)}/schedule-plans/${encodeURIComponent(planId)}/review`,
    ),

  reviewTournamentSchedulePlan: (
    tournamentId: string,
    planId: string,
    command: TournamentScheduleReviewCommand,
  ) =>
    httpClient.post<TournamentScheduleReview>(
      `${route(tournamentId)}/schedule-plans/${encodeURIComponent(planId)}/review`,
      command,
    ),

  publishTournamentSchedulePlan: (
    tournamentId: string,
    planId: string,
    command: TournamentPlanCommand,
  ) =>
    httpClient.post<TournamentPublishedSchedule>(
      `${route(tournamentId)}/schedule-plans/${encodeURIComponent(planId)}/publish`,
      command,
    ),

  rollbackTournamentSchedulePlan: (
    tournamentId: string,
    planId: string,
    command: TournamentPlanCommand,
  ) =>
    httpClient.post<TournamentPublishedSchedule>(
      `${route(tournamentId)}/schedule-plans/${encodeURIComponent(planId)}/rollback`,
      command,
    ),

  getTournamentDispatcherState: (tournamentId: string) =>
    httpClient.get<TournamentDispatcherState>(
      `${route(tournamentId)}/dispatcher`,
    ),

  applyTournamentDispatcherControlCommand: (
    tournamentId: string,
    command: TournamentDispatcherControlCommand,
  ) =>
    httpClient.post<TournamentDispatcherState>(
      `${route(tournamentId)}/dispatcher/commands`,
      command,
    ),

  getTournamentDispatcherRecommendations: (tournamentId: string) =>
    httpClient.get<TournamentDispatchDecision[]>(
      `${route(tournamentId)}/dispatcher/recommendations`,
    ),
};
